export default __webpack_public_path__ + "static/media/eye-regular.b15919b4.svg";